"use client";

import { setUseVehicleSelectionModal } from "action/utils/setUseVehicleSelectionModal";
import { getProductPricesApi } from "api/category/get-product-prices";
import getProductPriceApi from "api/category/getProductPrice";
import { getUpdatedProductPrices } from "component/productHelper";
import { RootState } from "interfaces/generics.type";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductContainer from "./ProductContainer";
import withUpdatedPriceInventory from "./withUpdatedPriceInventory";

function ProductContainerWrapper(props) {
  const { businessCustomer, refreshStatus } = useSelector((store: RootState) => store.authenticationState);
  const dispatch = useDispatch();
  const { actualResponse } = props;
  const { product, useVehicleSelectionOptionsModal } = actualResponse;
  const [updatedProduct, setUpdatedProduct] = useState(actualResponse.product);
  const [clientSideProductApiResReady, setClientSideProductApiResReady] = useState(false);

  useEffect(() => {
    if (refreshStatus === "complete") {
      if (!businessCustomer) {
        getProductPriceApi(product.sku)
          .then(({ data }) => {
            const productsWithNewPrice = getUpdatedProductPrices(data, [product]);
            setUpdatedProduct(productsWithNewPrice[0]);
            setClientSideProductApiResReady(true);
          });
      } else {
        getProductPricesApi([product.sku])
          .then(({ data }) => {
            const productsWithNewPrice = getUpdatedProductPrices(data, [product]);
            setUpdatedProduct(productsWithNewPrice[0]);
            setClientSideProductApiResReady(true);
          });
      }
    }
  }, [businessCustomer, actualResponse.product]);

  useEffect(() => {
    dispatch(setUseVehicleSelectionModal(useVehicleSelectionOptionsModal));

    return () => {
      dispatch(setUseVehicleSelectionModal(false));
    };
  }, [useVehicleSelectionOptionsModal]);

  const nextProps = {
    ...props,
    actualResponse: { ...actualResponse, product: updatedProduct },
    clientSideProductApiResReady,
  };

  return (
    <ProductContainer {...nextProps} />
  );
}

export default withUpdatedPriceInventory(ProductContainerWrapper);
